import Vue from 'vue/dist/vue.min.js';
import EventBus from './event-bus'
import store from './store';

const MenuTopBar = () => {
    let topBar = document.querySelector('.top-bar');

    let MenuTopBarConstructor = () => {
        Vue.component('top-bar', {
            data: function() {
                return {
                    activeNav: null,
                    isOpen: null
                }
            },
            watch: {
                isOpen: function() {
                    // handle closing subnav on outside click
                    if (this.isOpen) {
                        document.addEventListener("click", this.outsideClick);
                    } else {
                        document.removeEventListener("click", this.outsideClick);
                    }
                }
            },
            methods: {
                setNav(id) {
                    this.activeNav = id;
                },
                outsideClick(e) {
                    let target = e.target;
                    let topnav = document.querySelector('.top-bar');
                    if (!topnav.contains(target)) {
                        this.isOpen = false;
                        this.activeNav = null;
                    }
                }
            },
            mounted() {
                //give each nav item an id if it has a subnav
                this.$el.querySelectorAll('.top-bar__item').forEach((item, index) => {
                    if (item.querySelector('.top-bar__subnav')) {
                        item.dataset.id = index;
                    }
                });
                // listen for click events from nav items
                EventBus.$on('setNav', (id) => {
                    this.setNav(id);
                });
                // recieve open state from children to handle closing on outside click
                EventBus.$on('openState', (state) => {
                    this.isOpen = state;
                });
            }
        });
        Vue.component('top-bar-item', {
            props: ['activeNav'],
            data: function() {
                return {
                    navId: null,
                    isActive: false,
                    hasSubNav: false
                }
            },
            watch: {
                activeNav: function() {
                    this.isActive = ((this.activeNav == this.navId) && this.navId !== null) ? true : false;
                },
                isActive: function() {
                    // send open state to parent to handle closing on outside click
                    EventBus.$emit('openState', this.isActive ? true : false);
                }
            },
            methods: {
                // emit click event to parent
                handleClick(e) {
                    //set active state only if item has subnav
                    this.isActive = this.hasSubNav ? !this.isActive : false;
                    EventBus.$emit('setNav', this.navId);
                },
            },
            mounted() {
                // wait till next render to get id that's added by parent
                this.$nextTick(() => {
                    this.navId = this.$el.dataset.id || null;
                    this.hasSubNav = this.$el.dataset.id ? true : false;
                });
            }
        });

        Vue.component('lang-selector', {
            data: function() {
                return {
                    activeLang: null,
                    allLangs: [],
                    store: store
                }
            },
            methods: {
            },
            mounted() {
               
            }
        });

        Vue.component('lang-selector-item', {
            props: ['allLangs','activeLang'],
            data: function() {
                return {
                    lang: null,
                    isActive: false
                }
            },
            // watch: {
            //     activeLang: function() {
            //         this.isActive = this.activeLang === this.lang ? true : false;
            //     }
            // },
            methods: {
             selectLang(e) {
                    // this.activeLang = this.lang;
                    // EventBus.$emit('set-lang', this.lang);
                    let lang = e.currentTarget.dataset.lang;
                    if (lang) {
                        document.cookie = `selectedLanguage=${lang}; path=/; max-age=31536000;`;
                    }
                },
            
            },
            mounted() {
                // this.lang = this.$el.getAttribute('href').slice(1).toLowerCase();
                // this.isActive = this.activeLang == this.lang ? true : false;
            }
        });

        new Vue({
            el: `.top-bar`,
            store: store
        }).$mount(`.top-bar`, true);
    }

    if (topBar) {
        MenuTopBarConstructor();
    }
}

export default MenuTopBar;